import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import VueMarkdown from 'vue-markdown';
import Loading from '@/components/Loading.vue';
import MonsterPower from './MonsterPower.vue';
import MonsterRoll20 from './MonsterRoll20.vue';
let MonsterDescription = class MonsterDescription extends Vue {
    get abilityScores() {
        return this.monster && [
            { score: 'STR', value: this.monster.strength, modifier: this.addPlus(this.monster.strengthModifier) },
            { score: 'DEX', value: this.monster.dexterity, modifier: this.addPlus(this.monster.dexterityModifier) },
            { score: 'CON', value: this.monster.constitution, modifier: this.addPlus(this.monster.constitutionModifier) },
            { score: 'INT', value: this.monster.intelligence, modifier: this.addPlus(this.monster.intelligenceModifier) },
            { score: 'WIS', value: this.monster.wisdom, modifier: this.addPlus(this.monster.wisdomModifier) },
            { score: 'CHA', value: this.monster.charisma, modifier: this.addPlus(this.monster.charismaModifier) }
        ];
    }
    behaviors(type) {
        return this.monster && this.monster.behaviors.filter(({ monsterBehaviorType }) => monsterBehaviorType === type);
    }
    addPlus(value) {
        return value >= 0 ? '+' + value : value.toString();
    }
    hasListOrOther(field) {
        return this.monster && (this.monster[field].length ||
            this.monster[field + 'Other']);
    }
    joinWithOther(field) {
        return [
            ...(this.monster && this.monster[field]) || [],
            ...(this.monster && this.monster[field + 'Other']) || []
        ].join(', ');
    }
};
__decorate([
    Prop(Object)
], MonsterDescription.prototype, "monster", void 0);
__decorate([
    Prop(Boolean)
], MonsterDescription.prototype, "isAtDetail", void 0);
MonsterDescription = __decorate([
    Component({
        components: {
            VueMarkdown,
            Loading,
            MonsterPower,
            MonsterRoll20
        }
    })
], MonsterDescription);
export default MonsterDescription;
